/**
 * Navigation & Category Configuration
 *
 * Menu IDs, special category IDs, and navigation-related settings.
 * These are database IDs that should be consistent across environments.
 */

// =============================================================================
// MENUS
// =============================================================================

export const PRIMARY_MENU_ID = 5

// =============================================================================
// SPECIAL CATEGORIES
// =============================================================================

// Category pages with special behavior
export const NEW_CATEGORY_ID = 398           // "New" arrivals - sorted by newest
export const INVENTORY_CATEGORY_ID = 359     // In-stock items - different filtering
export const SALE_CATEGORY_ID = 555          // Sale items

// Outdoor section
export const OUTDOOR_BRANDS_CATEGORY_ID = 822

// =============================================================================
// MENU CATEGORY IDS (for mega menu rendering)
// =============================================================================

export const DESIGNER_MENU_CATEGORY_ID = 10
export const BRANDS_MENU_CATEGORY_ID = 11
export const OUTDOOR_MENU_CATEGORY_ID = 819
export const OUTDOOR_BRANDS_SUBMENU_CATEGORY_ID = 822
export const RUGS_MENU_CATEGORY_ID = 817
